import Vue from 'vue'
import Vuex from 'vuex'
import router from "@/router"
console.log(router)
Vue.use(Vuex)




let href = window.location.hash;
let project_code = href.substring(href.indexOf("#/")+2,href.indexOf("/",2));


export default new Vuex.Store({
	state: {
		user: {},//用户信息
		project: {},//任务信息
		exam: {},//考试相关信息
		answer: {},//答案,
		config: {},//配置

	},
	mutations: {
		user: (state, user) => {
			// console.log(project_code,"project_code",window.location.hash)
			if (JSON.stringify(user) == '{}') {
				localStorage.removeItem(`${project_code}_user`);
			} else {

				localStorage.setItem(`${project_code}_user`, JSON.stringify(user));
			}
			state.user = user;
		},
		project: (state, project) => {
			state.project = project;

			if (JSON.stringify(project) == '{}') {
				localStorage.removeItem(`${project_code}_project`);

			} else {
				localStorage.setItem(`${project_code}_project`, JSON.stringify(project));
			}
		},

		exam: (state, exam) => {

			state.exam = exam;

			if (JSON.stringify(exam) == '{}') {
				localStorage.removeItem(`${project_code}_exam`);
			} else {
				localStorage.setItem(`${project_code}_exam`, JSON.stringify(exam));
			}
		},
		answer: (state, answer) => {
			state.answer = answer;
			if (JSON.stringify(answer) == '{}') {
				localStorage.removeItem(`${project_code}_answer`);
			} else {
				localStorage.setItem(`${project_code}_answer`, JSON.stringify(answer));
			}
		},
		config: (state, config) => {

			state.config = config;
			if (JSON.stringify(config) == '{}') {
				localStorage.removeItem(`${project_code}_config`);
			} else {

				localStorage.setItem(`${project_code}_config`, JSON.stringify(config));
			}
		},


	},
	actions: {
	},
	modules: {
	}
})
